import Route from '@ember/routing/route'

export default class FastPhonicsLessonsRoute extends Route {
  queryParams = {
    filterPhase: {
      replace: true,
      refreshModel: true,
    },
  }
}
